import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import './navbarPesquisamineral.css';
import localImage from './PesquisaMineral.jpg';
import { Navbar, Container, Row, Col, Button, Offcanvas } from 'react-bootstrap';
import styles from './StyledButton.module.css';
import marcageo from './marcageo+.png';

function NavbarPesquisamineral() {

  const [backgroundImage, setBackgroundImage] = useState(localImage);
  const [showSidebar, setShowSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const handleCloseSidebar = () => {
    setShowSidebar(false);
    setBackgroundImage(images[0])
  }
  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    setBackgroundImage(images[0]);

  }
  const images = [
    localImage,

  ];
  return(  <div className="home">
    <div className="bannerNav" style={{ backgroundImage: `url(${backgroundImage})` }}>

      <Container>
        <div>

          <div className="text-center">
            {showSidebar === false ? (<div className="image-wrapper">
              {/* <img src={marcageo} className="image-adjust" alt="Descrição" />
    <img src={Frase} className="image-adjust" alt="Descrição" /> */}
            </div>) : null}
          </div>

        </div>
      </Container>
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>
      </div>
    </div>
    <div className="language-buttons">
      <Button variant="outline" className="rounded-circle">
        <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
      </Button>
      <Button variant="outline" className="rounded-circle">
        <img src="../Images/BandeiraPortugal.png" alt="Português" />
      </Button>
    </div>
    <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
      <div className="offcanvas-header">
        
        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
      </div>
      <Offcanvas.Body>
        <ul>
          <li className={`${liClicked ? 'li-slide-right' : ''}`} >
            <Link to="/app/home" style={{ textDecoration: 'none' }}>
              <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
          </li>
          {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
          <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
            <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
          </span></Button>
        </li> */}
          {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
          <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
            <i className="bi bi-chevron-right"></i>
          </span></Button>
        </li> */}
          {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
          <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
            <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
          </span></Button>
        </li> */}
        </ul>
      </Offcanvas.Body>
    </Offcanvas>
    <div className="green-bar">
      <div className="button-grid" >

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', marginTop: '-8%' }}>



          <button className="btn btn-success mt-4 hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}>  <Link to='/app/Cadastro_Furo' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Cadastro do Furo</Link></button>

          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/Boletim_PesquisaMineral' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Boletim de Sondagem</Link></button>

        </div>

        {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>

        <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/QuadroResulmo' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Quadro de Resumo</Link></button>


        <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/relatorio-sequencial' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Relatorio Sequencial</Link></button>

        <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#187A40', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}></button>

      </div> */}


      </div>


    </div>
    <div className="footer">
      <img src={marcageo} className="image-adjustLab" />
    </div>

  </div>
  )
}

export default NavbarPesquisamineral;